/** Global tunables. Quality tiers are chosen at boot but overridable via ?quality=. */
export const QUALITY = {
  ultra:  { dpr: 2.0, shadowMap: 4096, cascades: 4, crowdMax: 900, particleMax: 24000, ssao: true,  bloom: true, motionBlur: true, grassDensity: 1.0, aa: 'taa', reflections: true, decals: 512 },
  high:   { dpr: 1.6, shadowMap: 2048, cascades: 3, crowdMax: 600, particleMax: 16000, ssao: true,  bloom: true, motionBlur: true, grassDensity: 0.7, aa: 'smaa', reflections: true, decals: 384 },
  medium: { dpr: 1.2, shadowMap: 1536, cascades: 2, crowdMax: 380, particleMax: 9000,  ssao: false, bloom: true, motionBlur: false, grassDensity: 0.4, aa: 'smaa', reflections: false, decals: 192 },
  low:    { dpr: 1.0, shadowMap: 1024, cascades: 2, crowdMax: 220, particleMax: 4500,  ssao: false, bloom: true, motionBlur: false, grassDensity: 0.15, aa: 'none', reflections: false, decals: 96 },
  potato: { dpr: 0.75, shadowMap: 512, cascades: 1, crowdMax: 120, particleMax: 2000,  ssao: false, bloom: false, motionBlur: false, grassDensity: 0.0, aa: 'none', reflections: false, decals: 48 },
};

export const CFG = {
  quality: 'high',
  q: QUALITY.high,
  /** Simulation runs at a fixed rate; rendering interpolates. */
  fixedHz: 60,
  fixedDt: 1 / 60,
  maxFrameDt: 0.25,
  /** World scale: 1 unit = 1 metre. */
  world: { size: 520, half: 260, groundY: 0 },
  player: {
    height: 1.85, radius: 0.42,
    walkSpeed: 4.2, runSpeed: 8.6, sprintSpeed: 12.0,
    accel: 46, decel: 34, turnRate: 13.0,
    maxHp: 1000, maxMusou: 1000, musouRegen: 6,
  },
  combat: {
    hitstopBase: 0.055, hitstopHeavy: 0.11, hitstopMusou: 0.16,
    comboWindow: 0.42, inputBuffer: 0.24,
    launchGravity: -22, knockbackDrag: 4.2,
  },
  // The rig aims at a point `height` above the player and `dist` behind, so the
  // effective downward angle is pitch + atan(height/dist) — 3.3/8.4 plus 0.20
  // put the default gameplay camera 31 degrees down, an RTS view with no
  // horizon and no sky in frame. 20 degrees is the DW framing and puts the
  // skyline back in the top of the shot.
  camera: { fov: 52, near: 0.25, far: 900, dist: 8.4, height: 2.55, pitch: -0.07 },
  debug: { headless: false, showStats: false, freeCam: false, wireframe: false },
};

export function applyQuality(name) {
  if (!QUALITY[name]) name = 'high';
  CFG.quality = name; CFG.q = QUALITY[name];
  return CFG.q;
}

/** Parse ?quality=&seed=&scenario=&headless=&stats= from the URL. */
export function readUrlOverrides(search = location.search) {
  const p = new URLSearchParams(search);
  const out = {};
  if (p.has('quality')) { out.quality = p.get('quality'); applyQuality(out.quality); }
  if (p.has('seed')) out.seed = parseInt(p.get('seed'), 10) || 1;
  if (p.has('scenario')) out.scenario = p.get('scenario');
  if (p.has('headless')) { out.headless = p.get('headless') !== '0'; CFG.debug.headless = out.headless; }
  if (p.has('stats')) CFG.debug.showStats = p.get('stats') !== '0';
  if (p.has('dpr')) CFG.q = { ...CFG.q, dpr: parseFloat(p.get('dpr')) };
  return out;
}
